/* eslint-disable ember/classic-decorator-no-classic-methods, ember/no-get */
import Service, { service } from '@ember/service';
import { isEmpty } from '@ember/utils';

export default class PermissionsService extends Service {
  @service
  session;

  levels = Object.freeze([
    'urn:linced:organisation:role:learner',
    'urn:linced:organisation:role:caregiver',
    'urn:linced:organisation:role:staff',
    'urn:linced:organisation:role:admin',
    'urn:linced:meta:manager',
    'urn:linced:meta:admin',
  ]);

  meet(level) {
    const [valid, userLevel, checkLevel] = this.getLevels(level);

    return valid && userLevel >= checkLevel;
  }

  equal(level) {
    const [valid, userLevel, checkLevel] = this.getLevels(level);

    return valid && userLevel === checkLevel;
  }

  exceed(level) {
    const [valid, userLevel, checkLevel] = this.getLevels(level);

    return valid && userLevel > checkLevel;
  }

  getLevels(level) {
    let userLevel = this.get('session.scopes'),
      levels = this.levels;

    if (isEmpty(userLevel)) {
      return [false, -1, -1];
    }

    userLevel = userLevel[0];

    if (levels.includes(userLevel) && levels.includes(level)) {
      return [true, levels.indexOf(userLevel), levels.indexOf(level)];
    }

    return [false, -1, -1];
  }
}
